<script>
import './stylesheets/components/VsToaster';

import VsToast from './VsToast';

export default {
  props: ['notifications'],
  components: {
    VsToast,
  },
};
</script>

<template lang='pug'>
.toaster
  transition-group(name='toaster-transition')
    vs-toast(v-for='notification in notifications', :notification='notification', :key='notification', @remove-toast='$emit("remove-toast", $event)')
</template>